/**
 * This is the true token expiry value - The value we expect to be on the "exp"
 * field of the token.
 */
export const ACCESS_TOKEN_EXPIRY_MS = 10 * 60 * 1000;

/**
 * This is the period before expiry in which Confluence will attempt to fetch a
 * new token and cache it. This helps avoid sending requests are never
 * where the token expires while the request is still in-flight.
 *
 * We need to make sure we try re-fetch the token some
 * time after this period starts.
 *
 * Fetching before Conflunce retrieves a new token will result in our app
 * receiving exactly the same token as we were previously using
 */
export const CONFLUENCE_TOKEN_EXPIRY_GRACE_PERIOD_MS = 1 * 60 * 1000;

/**
 * Our grace period is halfway between Confluence's grace period. This gives
 * Confluence ample time to fetch a new token before we ask for that token.
 * Asking before this time would result in retrieving the same token as we
 * already have.
 */
export const CANVAS_TOKEN_EXPIRY_GRACE_PERIOD_MS =
  CONFLUENCE_TOKEN_EXPIRY_GRACE_PERIOD_MS / 2;

/**
 * This is the value we treat as the token expiry on the frontend. Note that
 * this value is smaller than what's on the "exp" field of the token.
 * @see {@link ACCESS_TOKEN_EXPIRY_MS}
 * @see {@link TOKEN_EXPIRY_GRACE_PERIOD}
 */
export const TOKEN_EXPIRY = ACCESS_TOKEN_EXPIRY_MS - CANVAS_TOKEN_EXPIRY_GRACE_PERIOD_MS;

export const TOKEN_FETCH_TIMEOUT_MS = 5000;
